<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card card-stats card-raised">
        <div class="card-body">
          <div class="row">
            <div class="col-md-3">
              <div class="statistics">
                <div class="info">
                  <div class="icon icon-danger">
                    <font-awesome-icon icon="user-plus" size="2x" />
                  </div>
                  <h3 class="info-title">
                    <animated-number :value="positive"></animated-number>
                  </h3>
                  <h6 class="stats-title">Positive</h6>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="statistics">
                <div class="info">
                  <div class="icon icon-success">
                    <font-awesome-icon icon="vial" size="2x" />
                  </div>
                  <h3 class="info-title">
                    <animated-number :value="tests"></animated-number>
                  </h3>
                  <h6 class="stats-title">Tests</h6>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="statistics">
                <div class="info">
                  <div class="icon icon-info">
                    <font-awesome-icon icon="virus-slash" size="2x" />
                  </div>
                  <h3 class="info-title">
                    <animated-number :value="negative"></animated-number>
                  </h3>
                  <h6 class="stats-title">Negative</h6>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="statistics">
                <div class="info">
                  <div class="icon icon-primary">
                    <font-awesome-icon icon="percentage" size="2x" />
                  </div>
                  <h3 class="info-title">
                    <animated-number :value="avgCP"></animated-number>
                  </h3>
                  <h6 class="stats-title">Avg. CP</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AnimatedNumber from "../AnimatedNumber";
import total_timeline from "../../assets/data/total_timeline.json";

export default {
  components: {
    AnimatedNumber,
  },
  data() {
    return {
      positive: 0,
      tests: 0,
      negative: 0,
      avgCP: 0.0,
      testWithCp:0
    };
  },
  mounted() {
    total_timeline.forEach((element) => {
      this.positive += element.noSymptonPositive + element.hasSymptonPositive;
      this.tests += element.testSum;
      this.avgCP += element.averageCp;
      if(element.averageCp!=0.0){
          this.testWithCp++;
      }
    });
    this.negative = this.tests - this.positive;
    this.avgCP = this.avgCP/this.testWithCp;
  },
};
</script>

<style>
</style>